import { contentItems, popularRanking } from "@/mocks/portal";

export default function PopularSection() {
  const featured = contentItems[2];

  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 md:gap-6">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs md:text-sm font-medium text-primary-600">
              <i className="ri-fire-line"></i>
              热门内容
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
              这几天被看得最多的料
            </h2>
          </div>
          <p className="text-sm md:text-base text-foreground-600 max-w-md leading-relaxed">
            按近 48 小时的阅读与转发综合排序，热度会随时间滚动更新。
          </p>
        </div>

        <div className="mt-8 md:mt-10 grid grid-cols-1 lg:grid-cols-5 gap-5 md:gap-6">
          <article className="lg:col-span-3 group relative rounded-card overflow-hidden border border-background-200 bg-background-950 min-h-[320px] md:min-h-[420px] flex">
            <img
              src={featured.cover}
              alt={`${featured.title} - 热门内容推荐配图`}
              title={`${featured.title} ${featured.category}`}
              className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/88 via-foreground-950/45 to-foreground-950/10"></div>
            <div className="relative z-10 mt-auto p-5 md:p-7">
              <div className="flex items-center gap-2">
                <span className="inline-flex items-center gap-1 rounded-full bg-primary-500 px-2.5 py-1 text-[11px] font-medium text-background-50">
                  <i className="ri-fire-fill"></i>
                  本周热度第一
                </span>
                <span className="rounded-full bg-background-50/15 border border-background-50/25 px-2.5 py-1 text-[11px] text-background-100 backdrop-blur">
                  {featured.category}
                </span>
              </div>
              <h3 className="mt-3 font-heading text-xl md:text-3xl font-bold text-background-50 leading-snug max-w-2xl">
                {featured.title}
              </h3>
              <p className="mt-2.5 text-sm md:text-base text-background-100/85 leading-relaxed max-w-2xl line-clamp-2">
                {featured.excerpt}
              </p>
              <div className="mt-4 flex items-center gap-4 text-xs md:text-sm text-background-100/80">
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-eye-line"></i>
                  {featured.readCount} 阅读
                </span>
                <span className="inline-flex items-center gap-1.5">
                  <i className="ri-time-line"></i>
                  更新于 {featured.date}
                </span>
              </div>
            </div>
          </article>

          <div className="lg:col-span-2 rounded-card border border-background-200 bg-background-100 p-4 md:p-6">
            <div className="flex items-center justify-between">
              <h3 className="font-heading text-lg md:text-xl font-bold text-foreground-950">热料榜单</h3>
              <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-refresh-line"></i>
                实时
              </span>
            </div>
            <ol className="mt-4 divide-y divide-background-200">
              {popularRanking.map((item) => (
                <li key={item.id} className="py-3 first:pt-0">
                  <a href="#hot" className="flex items-start gap-3 cursor-pointer group">
                    <span
                      className={`mt-0.5 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold shrink-0 ${
                        item.rank <= 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-700"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="min-w-0">
                      <span className="block text-sm font-medium text-foreground-900 leading-snug line-clamp-2 transition-colors group-hover:text-primary-600">
                        {item.title}
                      </span>
                      <span className="mt-1 flex items-center gap-2 text-[11px] text-foreground-500">
                        <span className="text-accent-700">{item.category}</span>
                        <span className="w-px h-3 bg-background-300"></span>
                        <span>{item.readCount} 阅读</span>
                      </span>
                    </span>
                  </a>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}